import React from 'react';
import ConnectedPlatform from '../../../shared/ConnectedPlatform';

const Connected = (props) => (
    <ConnectedPlatform {...props} platformName='Shopify' domainSuffix='.myshopify.com' dataTestIdPrefix='shopify' />
);

export default Connected;
